module.exports = __webpack_public_path__ + "img/warn_09.8df318d8.png";